import { mixin } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { BaseCell } from "../shared/BaseCell"
import { innerCellHorizontalPadding } from "../shared/Styles"

export const StyledCell = styled(BaseCell)`
  padding: 0 ${innerCellHorizontalPadding};
  display: flex;
  align-items: center;
`

export const Content = styled.div<{ linethrough: boolean }>`
  width: 100%;
  ${mixin.noWrapEllipsis};
  ${({ linethrough }) =>
    linethrough &&
    css`
      text-decoration: line-through;
    `}
`
